const checked = (value, options) => {
  if (value !== true) {
    return options.message || '必填';
  }
};

export default {
  checked
};
